module.exports = __webpack_public_path__ + "img/jxk_zgzt.c4344df8.svg";